import { BootStatus } from 'vrlcm-gui-types';
import { downloadFile, Http } from 'vrlcm-gui-utils';
import { BootstrapApiUri } from './uri';

export class BootstrapApi {
  public static async getBootStatus(): Promise<BootStatus> {
    try {
      const response = await Http.get(BootstrapApiUri.BOOT_STATUS_URL);
      return response.data.status;
    } catch (err) {
      return null;
    }
  }

  public static async downloadBootstrapLogs(): Promise<void> {
    const response = await Http.get(
      BootstrapApiUri.DOWNLOAD_BOOTSTRAP_LOGS_URL
    );
    const file = new Blob([response.data], {
      type: 'application/octet-stream'
    });
    downloadFile(file, 'bootstrap.log');
  }
}
